<template>
    <div>
        <v-server-table :ref="'inspectionList' + assetType" :url="`/inspections?assetType=${assetType}&assetId=${assetId}`" :columns="columns" :options="options">

            <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

            </div>

            <div slot="afterFilter" class="ml-2 mb-sm-0 mb-1 mt-sm-0 mt-1">
                <button class="btn btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                    <i class="fas fa-ban"></i>
                </button>
                <button class="btn btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                    <i class="fas fa-filter"></i>
                    <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                </button>
                <router-link to="inspections/create" class="btn btn-success ml-1" v-if="showCreateBtn">
                    <i class="fas fa-plus-square"></i> Entry
                </router-link>
            </div>

            <template slot="id" slot-scope="props">
                <router-link :to="`/inspections/${props.row.id}`" class="btn btn-sm btn-secondary">View</router-link>
            </template>

            <template slot="legacy_local_index" slot-scope="props">
                <router-link :to="`/inspections/${props.row.id}`">{{ props.row.legacy_local_index }}</router-link>
            </template>

            <template slot="part_nbr" slot-scope="props">
                <router-link :to="`/parts/${props.row.part_id}`" :title="`${props.row.description}. Click to View Part.`">{{ props.row.part_nbr }}</router-link>
            </template>

            <template slot="customer_name" slot-scope="props">
                <router-link :to="`/customers/${props.row.customer_id}`" title="View Customer">{{ props.row.customer_name }}</router-link>
            </template>

            <template slot="inspected_at" slot-scope="props">
                {{ props.row.inspected_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="closed_at" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.closed_at">Closed</label>
                <label class="badge badge-danger" v-else>Open</label>
            </template>

            <template slot="child_row" slot-scope="props">
                <div class="row my-3">
                    <div class="col-md-6">
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Entered:</div>
                            <div class="col-md-9 col-12">{{ props.row.inspected_at | moment("MM/DD/YYYY") }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Closed:</div>
                            <div class="col-md-9 col-12">{{ props.row.closed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">MFG:</div>
                            <div class="col-md-9 col-12">{{ props.row.mfg_location_name }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Model:</div>
                            <div class="col-md-9 col-12">{{ props.row.model }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Customer:</div>
                            <div class="col-md-9 col-12">{{ props.row.customer_name }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Part#:</div>
                            <div class="col-md-9 col-12">
                                <router-link :to="`/parts/${props.row.part_id}`">{{ props.row.part_nbr }}</router-link>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Description:</div>
                            <div class="col-md-9 col-12">
                                {{ props.row.description }}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Defect:</div>
                            <div class="col-md-9 col-12">
                                <label class="badge badge-danger">{{ props.row.defect_name }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Offsite Location:</div>
                            <div class="col-md-9 col-12">{{ props.row.offsite_location_name }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Shift Walk:</div>
                            <div class="col-md-9 col-12">{{ props.row.shift_walk_name }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Shift:</div>
                            <div class="col-md-9 col-12">{{ props.row.shift_name }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Rejected Qty:</div>
                            <div class="col-md-9 col-12">{{ props.row.qty_defect }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Rework Qty:</div>
                            <div class="col-md-9 col-12">{{ props.row.qty_rework }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">Audited Qty:</div>
                            <div class="col-md-9 col-12">{{ props.row.qty_audited }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-3 col-12 text-md-right text-muted">WO#:</div>
                            <div class="col-md-9 col-12">{{ props.row.wo_nbr }}</div>
                        </div>
                    </div>
                </div>

            </template>
        </v-server-table>

        <b-modal v-model="showFilters" :ref="'inspListFilters' + assetType" title="Entry Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Date Entered:</div>
                <div class="col-md-7 col-12">
                    <div class="row mb-1">
                        <div class="col-md-2 text-md-right">Start:</div>
                        <div class="col-md-10">
                            <b-form-datepicker v-model="filters['inspections.inspected_at_start']"></b-form-datepicker>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-md-2 text-md-right">End:</div>
                        <div class="col-md-10">
                            <b-form-datepicker v-model="filters['inspections.inspected_at_end']"></b-form-datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Date Closed:</div>
                <div class="col-md-7 col-12">
                    <div class="row mb-1">
                        <div class="col-md-2 text-md-right">Start:</div>
                        <div class="col-md-10">
                            <b-form-datepicker v-model="filters['inspections.closed_at_start']"></b-form-datepicker>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-md-2 text-md-right">End:</div>
                        <div class="col-md-10">
                            <b-form-datepicker v-model="filters['inspections.closed_at_end']"></b-form-datepicker>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Open/Closed:</div>
                <div class="col-md-7 col-12">
                    <b-form-select v-model="filters['inspections.open_closed']" :options="[{value: null, text: '-- Show All Open and Closed --'}, {value: 'open', text: 'Open'}, {value: 'closed', text: 'Closed'}]"></b-form-select>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Type:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.inspection_type_id']"
                        :options="types"
                        :reduce="type => type.id"
                        label="type_name"
                        placeholder="-- Select an Entry Type --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Exclude Type(s) <i class="fa fa-question-circle" title="Types selected in this filter will be excluded from the results"></i>:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.exclude_inspection_type_id']"
                        :options="types"
                        :reduce="type => type.id"
                        label="type_name"
                        placeholder="-- Select an Entry Type to Exclude --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Customer:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.customer_id']"
                        :options="customers"
                        :reduce="customer => customer.id"
                        label="customer_name"
                        placeholder="-- Select a Customer --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">User:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.user_id']"
                        :options="users"
                        :reduce="user => user.id"
                        label="name"
                        placeholder="-- Select a User --"
                        multiple ></v-select>

                        <a href="javascript:void(0)" v-on:click="assignedToMe()">Assigned To Me</a>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">MFG Locations:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.mfg_location_id']"
                        :options="mfgs"
                        :reduce="mfg => mfg.id"
                        label="mfg_location_name"
                        placeholder="-- Select an MFG Location --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Status:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.status_id']"
                        :options="statuses"
                        :reduce="status => status.id"
                        label="status_name"
                        placeholder="-- Select a Status --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Disposition:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['inspections.disposition_id']"
                        :options="dispositions"
                        :reduce="disposition => disposition.id"
                        label="disposition_name"
                        placeholder="-- Select a Disposition --"
                        multiple ></v-select>

                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            assetType: {
                type: String,
                required: false
            },

            assetId: {
                type: Number,
                required: false
            },

            showCreateBtn: {
                type: Boolean,
                default: false,
            },

            search: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                userTimezone: this.$root.timezone,
                showFilters: false,
                columns: ['id', 'legacy_local_index', 'name', 'customer_name', 'part_nbr', 'description', 'inspected_at', 'type_name', 'status_name', 'disposition_name', 'closed_at'],
                options: {
                    headings: {
                        id: 'Actions',
                        legacy_local_index: 'Index',
                        name: 'User',
                        customer_name: 'Customer',
                        part_nbr: 'Part#',
                        description: 'Desc.',
                        inspected_at: 'Entered',
                        type_name: 'Type',
                        status_name: 'Status',
                        disposition_name: 'Disposition',
                        closed_at: 'Open/Closed',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inspections.inspected_at',
                    },
                    texts:{
                        filterPlaceholder:"Search Entries",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('inspectionCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.filters = this.filters;

                        //Check for a query?

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'inspections.customer_id': [],
                    'inspections.inspection_type_id': [],
                    'inspections.exclude_inspection_type_id': [],
                    'inspections.user_id': [],
                    defect_id: [],
                    'inspections.mfg_location_id': [],
                    status_id: [],
                    disposition_id: [],
                    'inspections.open_closed': null,
                    'inspections.inspected_at_start': null,
                    'inspections.inspected_at_end': null,
                    'inspections.closed_at_start': null,
                    'inspections.closed_at_end': null,
                },

                //Set the part
                types: [],
                customers: [],
                defects: [],
                mfgs: [],
                statuses: [],
                dispositions: [],
            }
        },

        computed: {

            users(){
                //Using a computed allows changes to the state to be rendered
                return this.$store.state.users;
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            getFilters(){
                //Check the store for the filters
                if(this.$store.state.inspectionFilters)
                {
                    //Set it
                    this.setFilters(this.$store.state.inspectionFilters);

                    //Stop here
                    return;
                }

                //Send it
                this.$http.get('/inspections/filters')
                    .then(response => {
                        //Set the part
                        this.setFilters(response.data);

                        //Commmit
                        this.$store.commit('inspectionFilters', response.data);
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            setFilters(data){
                this.types = data.types;
                this.customers = data.customers;
                this.defects = data.defects;
                this.mfgs = data.mfgs;
                this.statuses = data.statuses;
                this.dispositions = data.dispositions;
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs['inspectionList' + this.assetType].refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs['inspectionList' + this.assetType].refresh();
            },

            assignedToMe(){
                //Set the filter
                this.filters['inspections.user_id'] = [this.$store.state.user.id];
            }
        },

        mounted() {
            //Get the filtes
            this.getFilters();

            //Check for a search
            if(this.search)
            {
                this.$refs['inspectionList' + this.assetType].setFilter(this.search);
                this.$refs['inspectionList' + this.assetType].refresh();
            }

            //Check for an AssetType
            switch(this.assetType)
            {
                //Check for Dashboard and Apply
                case 'my_dashboard':
                case 'open_dashboard':
                    //Set it
                    if(this.$store.state.user.mfg_location_id)
                    {
                        //Push onto the stack
                        this.filters['inspections.mfg_location_id'].push(this.$store.state.user.mfg_location_id);

                        //Redraw
                        this.applyFilters();
                    }
                    break;
            }
        }
    }
</script>
